import { specLines } from "../lib/products";

/* Product card in module markup. Written out (not <module>) because the
   Endorsed filter re-renders these in the browser: plain elements keep that
   cheap (no dynamic-tag runtime or serialized module content). */
<const/p=input.productData>
<li id=`source_${p.id}` data-product=p.name class="h-full">
  <a class="mod mod--link h-full" href=p.productURL target="_blank" rel="noopener noreferrer" aria-label=`${p.name} (opens in a new tab)`>
    <div class="mod-bar bar--kits">
      <span class="mod-title label"><span class="disc" aria-hidden="true"></span>${p.categories || "Kit"}</span>
    </div>
    <div class="mod-body">
      <div class="bg-tile flex items-center justify-center py-3 min-h-[96px] sm:min-h-[124px]">
        <img
          src=`/products/images/${p.imageURL}`
          alt=p.alt
          width="110"
          height="110"
          class="product-img max-h-[76px] sm:max-h-[110px] w-auto h-auto mx-auto"
          loading="lazy"
          decoding="async"
        />
      </div>
      <div class="p-3">
        <h3 class="text-[19px] leading-snug font-medium lowercase text-c-900" style="word-break: break-word; hyphens: auto;">${p.name}</h3>
        <ul class="mt-2 grid gap-1">
          <for|line, i| of=specLines(p.blurb)>
            <li class=["label text-c-400", i > 0 && "hidden sm:block"]>${line}</li>
          </for>
        </ul>
      </div>
    </div>
    <div class="mod-foot mod-foot--sm label">
      <span>Endorsed</span>
      <span>Get ↗</span>
    </div>
  </a>
</li>

<style>
  /* Product shots keep their color: they're objects, not photos. */
  .product-img { filter: none; }
</style>
